/**
 * Classification descriptions mapping
 * Maps classification labels to their descriptions
 */
export const CLASSIFICATION_DESCRIPTIONS: Record<string, string> = {
  'In-Use': 'Images showing the product being actively used, applied, or consumed by a person.',
  Lifestyle: 'Images showing the product in real-world use or context (hands, counters, textures, in-use shots).',
  'Benefit Highlight': 'Images that emphasize a key product benefit, result, or outcome.',
  'Before and After': 'Images showing a change or result — either packaging updates or product performance results.',
  'Product Swatch': 'Close-up images showing product color, texture, shade, or material samples.',
  Comparison: 'Side-by-side visuals showing this product against competitors or alternatives.',
  'Product Range': 'Images showcasing the full product line, available variants, colors, or flavors.',
  'Hero Image': 'The primary product image — a clean, front-facing shot of the product or packaging.',
  'Multi-Pack': 'Images showing multiple products together — variety packs, bundles, or multi-pack style shots.',
  'Included Items': 'Images displaying all items included in the package or what comes in the box.',
  'Feature Callout': 'Images focused on specific product features with callouts, annotations, or highlighted details.',
  'Alternate Product Views': 'Images showing the product from different angles — side, back, top, or bottom views.',
  Endorsements: 'Images featuring celebrity endorsements, expert recommendations, or influencer partnerships.',
  'Certification Mark':
    'Images highlighting certifications, seals, or quality marks (e.g., organic, non-GMO, FDA approved).',
  'Usage Instructions': 'Images showing how to use the product with step-by-step guides or application instructions.',
  'Size and Scale': 'Images that emphasize product size using reference objects (hands, rulers, coins) or labels.',
  'Product Facts Panel': 'Close-ups of nutrition facts, ingredient lists, or other on-pack information panels.',
};
